// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"2344f51e","80":"526d9650","397":"7bbd061a","542":"6e60285f","673":"6d0ce60c","846":"04f94561"}[chunkId] + ".chunk.js";
};